export default __webpack_public_path__ + "static/media/trick.514f3437.svg";